module.exports = __webpack_public_path__ + "static/media/up_emergency_bg.d07b5a7e.png";